export default __webpack_public_path__ + "static/media/HamburguerBlack.64b60f10.svg";